import { Inject } from '@odinjs/odin';

import { Route } from '@philips-emr/hpms-stipulator-commons';
import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { PanelAPI, TabControlAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';

import BaseController from './BaseController';

@Controller({ fragment: 'person-data' })
class PersonDataTabsController extends BaseController {

  @Inject('person-data-menu-tab-control')
  private tabAPI: TabControlAPI;
  @Inject('person-data-tab-panel-s')
  private panelS: PanelAPI;
  @Inject('person-data-tab-panel-n')
  private panelN: PanelAPI;

  @OnMount('person-data-layout')
  onMountLayout(): void {
    const twsFunc = StipulatorContext.isAllowedTwsFunction('9126_3');
    this.panelS.setVisible(twsFunc);
    this.panelN.setVisible(!twsFunc);
  }

  @OnMount('person-data-tab-panel-s')
  onMountTabs(): void {
    const { path: currentPath } = this.historyService.getMatch();

    if (currentPath == Route.BENEFICIARY_DATA_DETALHES) {
      this.tabAPI.setDefaultTab('solicitacoes-alteracoes');
    }

  }

}
export default PersonDataTabsController;
